<h4 class="section-header">Documents Requiring Acknowledgement</h4>
<span *ngIf="documentsLoading" class="pull-right spinner"></span>

<div [ngSwitch]="batch.Status">
   <div *ngSwitchCase="'edit'">
      <div class="panel-body">
         <h4 *ngIf="batch.HasSh">Safe Harbor</h4>
         <h4 *ngIf="batch.HasSpds && batch.HasSmms" class="section-header">Summary Plan Description (SPD) & Summary of
            Material Modifications (SMM)</h4>
         <h4 *ngIf="batch.HasSpds && !batch.HasSmms" class="section-header">Summary Plan Description (SPD)</h4>
         <h4 *ngIf="!batch.HasSpds && batch.HasSmms" class="section-header">Summary of Material Modifications (SMM)</h4>
         <!-- FOR SAFE HARBOR, NEED TO REPEAT THIS SECTION FOR EACH SH PLAN-->
         <h5>STEP 1: DISTRIBUTION DETAILS</h5>
         <div class="row" *ngIf="batch.HasSh">
            <div class="col-sm-4">
               <label>Effective Date:</label>
            </div>
            <div class="col-sm-8">{{batch.ShEffectiveDate | date:'MM/dd/yyyy'}}
            </div>
         </div>
         <div class="row">
            <div class="col-sm-4">
               <label>Date Distributed*:</label>
            </div>
            <div class="col-sm-8" style="display:inline-block">
               <p class="input-group">
                  <p-datepicker 
                     [styleClass]="DistributionDateErrorClass" 
                     [(ngModel)]="batch.DistributionDate"
                     placeholder="MM/DD/YYYY" [maxDate]="maxDate" [icon]="'arrow'"
                     (ngModelChange)="validateForm('DistributionDate', undefined)" [required]="true"
                     #dateDistributedcalendar>
                  </p-datepicker>
                  <span class="input-group-btn beneficiary-calendar" style="display:inline">
                     <a (click)="dateDistributedcalendar.toggle()"><i class="icon-utility-calendar"></i></a>
                  </span>
               </p>
            </div>
         </div>
         <div class="row">
            <div class="col-sm-4">
               <label>Your Method of Distribution*:</label>
            </div>
            <div class="col-sm-8">
               <select class="form-control" name="DistributionMethod" [(ngModel)]="batch.DistributionMethod"
                  (change)="validateForm('DistributionMethod', undefined)" [ngClass]="DistributionMethodErrorClass">
                  <option>- Select -</option>
                  <option> US Mail</option>
                  <option> Desk Delivery</option>
                  <option> Inbox Delivery</option>
                  <option> Electronic</option>
                  <option> Multiple Methods (Specify in Comments)</option>
                  <option> Other (Specify in Comments)</option>
               </select>
            </div>
         </div>
         <div class="row">
            <div class="col-sm-4">
               <label>Comments:</label>
            </div>
            <div class="col-sm-8">
               <textarea class="form-control" name="Comments" [ngClass]="CommentsErrorClass"
                  [(ngModel)]="batch.Comments" style="width:60%;"
                  (change)="validateForm('Comments', undefined)"></textarea>
            </div>
         </div>

         <div *ngIf="!batch.HasSh">
            <h5> STEP 2: PLAN PARTICIPANTS</h5>
            <i>Input the number of participants enrolled in each plan at the beginning of the year.</i>
            <br>
            <br>
            <table class="table">
               <thead>
                  <tr>
                     <th>SUBGROUP</th>
                     <th>PLAN DOCUMENT</th>
                     <th>DOCUMENT TYPE</th>
                     <th>#PARTICIPANTS</th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngFor="let submittedItem of batch.SubmittedItems">
                     <td style="width:40%">{{submittedItem.Organization}}</td>
                     <td style="width:20%;text-align:left">{{submittedItem.PlanDocument}}</td>
                     <td *ngIf="batch.DocType === 'SPD'" style="text-align:center">{{submittedItem.DocType}}</td>
                     <td *ngIf="batch.DocType === 'SMM'" style="text-align:center">{{submittedItem.DocType}}</td>
                     <td style="width:20%;text-align:center;">
                        <input [name]="'Participants' + submittedItem.Id" type="number" min="0"
                           oninput="this.value = this.value < 0 ? 0 : this.value"
                           [(ngModel)]="submittedItem.Participants"
                           (keyup)="participantsChanged();validateForm('Participants' + submittedItem.Id, false)"
                           (change)="participantsChanged();validateForm('Participants' + submittedItem.Id, false)"
                           [ngClass]="submittedItem.ErrorClass">
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
         <div *ngIf="!batch.HasSh">
            <h5>STEP 3: NON-ENGLISH LANGUAGE SURVEY</h5>
            <i>Please complete the following questions so that we may determine if your co-op's {{batch.DocTypeDisplay}}
               require this notice.</i>
            <br>
            <br>
            <div *ngIf="batch.FewerThan100Participants"> <strong> Plans with fewer than 100 participants</strong>
               <br>
            </div>
            <table *ngIf="batch.FewerThan100Participants" style="border: solid 1px #cccccc;" class="table">
               <tbody>
                  <tr style="border:none;">
                     <td> <span>Are 25% or more of all plan participants only literate in a non-English language?</span>
                     </td>
                     <td style="width:221px;">
                        <div>
                           <input type="radio" name="English25Percent" [checked]="batch.English25Percent == true"
                              (change)="batch.English25Percent = true; validateForm('English25Percent', false)"
                              style="margin:3px; padding-right:5px;">
                           <span style="padding-right:10px;"> Yes</span>
                           <input type="radio" name="English25Percent" [checked]="batch.English25Percent == false"
                              (change)="batch.English25Percent = false; validateForm('English25Percent', false)"
                              style="margin:3px;">
                           <span>No</span>
                           <i class="icon-status-warning" style="position:relative;top:5px;left:8px;"
                              *ngIf="English25PercentError" title="{{radioButtonErrorMessage}}"></i>
                        </div>
                     </td>
                  </tr>
                  <tr *ngIf="batch.English25Percent" style="border:none;">
                     <td> <span> Total number of plan participants who read only the same non-English language: </span>
                     </td>
                     <td>
                        <input name="NumParticipantsLesser" type="number" min="0"
                           oninput="this.value = this.value < 0 ? 0 : this.value"
                           [(ngModel)]="batch.NumParticipantsLesser"
                           (change)="validateForm('NumParticipantsLesser', false)"
                           [ngClass]="NumParticipantsLesserErrorClass">
                     </td>
                  </tr>
                  <tr *ngIf="batch.English25Percent" style="border:none;">
                     <td> <span>What is the non-English language?</span></td>
                     <td>
                        <input name="NonEnglishLanguageLesser" type="text" [(ngModel)]="batch.NonEnglishLanguageLesser"
                           (change)="validateForm('NonEnglishLanguageLesser', false)"
                           [ngClass]="NonEnglishLanguageLesserErrorClass">
                        <div *ngIf="!batch.MoreThan100Participants && batch.FewerThan100Participants 
                              && batch.English25Percent !== undefined && !batch.English25Percent 
                              && batch.English500 !== undefined && batch.English500" style="margin-bottom:15px"
                           class="dismissibleAlert information"></div>
                     </td>
                  </tr>
               </tbody>
            </table>
            <div *ngIf="((batch.MoreThan100Participants && batch.FewerThan100Participants && batch.English25Percent !== undefined && !batch.English25Percent && batch.English500 !== undefined && batch.English500 )) "
                  style="margin-bottom:15px" class="dismissibleAlert information">
               <div class="message">
                  <div style="text-align:center;" class="bodyText">A non-English survey is not required for this
                     submission.</div>
               </div>
            </div>
            <div *ngIf="batch.MoreThan100Participants"> <strong>Plans with 100 or more participants</strong>
               <br>
            </div>
            <table *ngIf="batch.MoreThan100Participants" style="border: solid 1px #cccccc;" class="table">
               <tbody>
                  <tr style="border:none;">
                     <td> <span>Are 500 or more of your plan participants literate only in a non-English
                           language?</span>
                     </td>
                     <td style="width:221px;">
                        <div> <span class="padding-right-5">
                              <input type="radio" name="English500" [checked]="batch.English500 == true"
                                 (change)="batch.English500 = true;validateForm('English500', false);"
                                 style="margin:3px;padding-right:5px;">
                              <span style="padding-right:10px;">Yes</span> </span>
                           <input type="radio" name="English500" [checked]="batch.English500 == false"
                              (change)="batch.English500 = false;validateForm('English500', false);" style="margin:3px">
                           <span>No</span>
                           <i class="icon-status-warning" style="position:relative;top:5px;left:8px;"
                              *ngIf="English500Error" title="{{radioButtonErrorMessage}}"></i>
                        </div>
                     </td>
                  </tr>
                  <tr *ngIf="batch.English500" style="border:none;">
                     <td> <span>Are 10% or more of your plan participants literate only in a non-English
                           language?</span>
                     </td>
                     <td>
                        <div>
                           <span class="padding-right-5">
                              <input type="radio" name="English10Percent" [checked]="batch.English10Percent == true"
                                 (change)="batch.English10Percent = true;validateForm('English10Percent', false);"
                                 style="margin:3px;padding-right:5px;">
                              <span style="padding-right:10px;">Yes</span>
                           </span>
                           <input type="radio" name="English10Percent" [checked]="batch.English10Percent == false"
                              (change)="batch.English10Percent = false;validateForm('English10Percent', false)"
                              style="margin:3px;">
                           <span>No</span>
                           <i class="icon-status-warning" style="position:relative;top:5px;left:8px;"
                              *ngIf="English10PercentError" title="{{radioButtonErrorMessage}}"></i>
                        </div>
                     </td>
                  </tr>
                  <tr *ngIf="batch.English500" style="border:none;">
                     <td> <span>Total number of plan participants who read only the same non-English language:</span>
                     </td>
                     <td>
                        <input name="NumParticipantsMore" type="number" min="0"
                           oninput="this.value = this.value < 0 ? 0 : this.value"
                           [ngClass]="NumParticipantsMoreErrorClass" [(ngModel)]="batch.NumParticipantsMore"
                           (change)="validateForm('NumParticipantsMore', false)">
                     </td>
                  </tr>
                  <tr *ngIf="batch.English500" style="border:none;">
                     <td> <span>What is the non-English language?</span></td>
                     <td>
                        <input name="NonEnglishLanguageMore" [ngClass]="NonEnglishLanguageMoreErrorClass" type="text"
                           [(ngModel)]="batch.NonEnglishLanguageMore"
                           (change)="validateForm('NonEnglishLanguageMore', false)">
                     </td>
                  </tr>
               </tbody>
            </table>
            <div
               *ngIf="((!batch.MoreThan100Participants && batch.FewerThan100Participants && batch.English25Percent !== undefined && !batch.English25Percent) 
                    || (!batch.FewerThan100Participants && batch.MoreThan100Participants && batch.English500 !== undefined && !batch.English500) 
                    || (batch.FewerThan100Participants && batch.MoreThan100Participants && batch.English500 !== undefined && !batch.English500 && batch.English25Percent !== undefined))"
               style="margin-bottom:15px" class="dismissibleAlert information">
               <div class="message">
                  <div style="text-align:center;" class="bodyText">A non-English survey is not required for this
                     submission.</div>
               </div>
            </div>
         </div>
      </div>
      <div style="text-align:right;">
         <div class="btn-toolbar pull-right">
            <table>
               <tbody>
                  <tr>
                     <td style="width:300px;">
                        <a class="btn btn-link" (click)="reset()">Cancel</a>
                        <button class="btn btn-primary" type="submit" (click)="send()"
                           [disabled]="SendDisabled">CONTINUE</button>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>
   <div *ngSwitchCase="'preview'">
      <div class="dismissibleAlert information bodytext" [innerHTML]=baSubmitInstructions></div>
      <div class="panel-body">
         <h4 *ngIf="batch.HasSh">Safe Harbor</h4>
         <h4 *ngIf="batch.HasSpds && batch.HasSmms">Summary Plan Description (SPD) & Summary of Material
            Modifications (SMM)</h4>
         <h4 *ngIf="batch.HasSpds && !batch.HasSmms">Summary Plan Description (SPD)</h4>
         <h4 *ngIf="!batch.HasSpds && batch.HasSmms">Summary of Material Modifications (SMM)</h4>
         <h5>DISTRIBUTION DETAILS</h5>
         <div>
            <div *ngIf="batch.HasSh">Effective Date: {{ batch.ShEffectiveDate | date:'MM/dd/yyyy'}}</div>
            <div>Date Distributed: {{ batch.DistributionDate | date:'MM/dd/yyyy'}}</div>
            <div>Your Method of Distribution: {{batch.DistributionMethod}}</div>
            <div>Comments: {{batch.Comments? batch.Comments : 'N/A'}} </div>
            <br />
         </div>
         <div *ngIf="!batch.HasSh">
            <h5>PLAN PARTICIPANTS</h5>
            <table class="table">
               <thead>
                  <tr>
                     <th style="cursor:pointer; width:37%;">SUBGROUP &nbsp;</th>
                     <th style="width:23%;cursor:pointer;padding:12px 5px !important;" class="borderLeft">PLAN DOCUMENT
                        &nbsp;</th>
                     <th style="cursor:pointer;width:20%;text-align:left;padding:12px 5px !important;">DOCUMENT TYPE
                        &nbsp;
                     </th>
                     <th style="width:20%;cursor:pointer;text-align:left;padding:12px 5px !important;">#PARTICIPANTS
                        &nbsp;
                     </th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngFor="let item of batch.SubmittedItems">
                     <td>{{item.Organization | uppercase}}</td>
                     <td style="padding:12px 5px !important;"> {{item.PlanDocument}}</td>
                     <td style="padding:12px 5px !important;text-align:left">{{item.DocType}}</td>
                     <td style="padding:12px 5px !important;text-align:left;">{{item.Participants}}</td>
                  </tr>
               </tbody>
            </table>
            <h5>NON-ENGLISH LANGUAGE SURVEY</h5>
            <div>
               <div *ngIf="batch.FewerThan100Participants">
                  <b>Plans with fewer than 100 participants</b>
                  <div>Are 25% or more of all plan participants only literate in a non-English language?
                     {{batch.English25Percent? 'Yes' : 'No'}} </div>
                  <div
                     *ngIf="!batch.English25Percent &amp;&amp; (!batch.MoreThan100Participants || (batch.MoreThan100Participants && batch.English500))">
                     A non-English survey is not required.</div>
                  <div *ngIf="batch.English25Percent">
                     <div>Total number of plan participants who read only the same non-English language:
                        {{batch.NumParticipantsLesser}}</div>
                     <div>What is the non-English language? {{batch.NonEnglishLanguageLesser}} </div>
                  </div>
               </div>
               <br />
               <div *ngIf="batch.MoreThan100Participants">
                  <b>Plans with 100 or more participants</b>
                  <div>Are 500 or more of your plan participants literate only in a non-English language?
                     {{batch.English500? 'Yes' : 'No'}}</div>
                  <div *ngIf="!batch.English500">A non-English survey is not required.</div>
                  <div *ngIf="batch.English500">
                     <div>Are 10% or more of your plan participants literate only in a non-English language?
                        {{batch.English10Percent? 'Yes' : 'No'}}</div>
                     <div>Total number of plan participants who read only the same non-English language:
                        {{batch.NumParticipantsMore}}</div>
                     <div>What is the non-English language? {{batch.NonEnglishLanguageMore}}</div>
                  </div>
                  <br />
               </div>
            </div>
         </div>
         <div *ngIf="!batch.SaveActionCompleted">
            <hr>
            <div>
               <b *ngIf="batch.HasSh">CONFIRMATION</b>
               <b *ngIf="batch.HasSmms || batch.HasSpds">CONFIRMATIONS</b>
               <br/><br/>
            </div>
            <div>
               <b>Please check the attestation below:</b>
               <br/><br/>
               <div class="FlexContainer">
                     <span>
                        <input type="checkbox" class="ConfirmationCheckbox" name="Attestation" [(ngModel)]="batch.Attestation">
                     </span>
                     <span> I attest that I have reviewed the NRECA plan document(s) and that the plan documents are in 
                        accordance with the cooperative's HR policies as described in the box above.
                     </span>
               </div>
               <div *ngIf="batch.AttestationNotChecked">
                  <div style='color:red;font-weight:bold;'>You must attest that the NRECA plan document(s) are correct and in accordance with your cooperative's HR policies.</div>
               </div>
            </div>
            <br/>
            <div *ngIf="!batch.HasSh">
               <b>Please verify the number of plan participants:</b>
               <br/><br/>
               <div class="FlexContainer">
                  <span>
                     <input type="checkbox" class="ConfirmationCheckbox" name="VerifiedNumParticipants" [(ngModel)]="batch.VerifiedNumParticipants">
                  </span>
                  <span>
                     I have reviewed and confirmed that the total number of participants for each plan listed 
                     above is correct. I understand that this number cannot be modified after selecting submit. (To make changes, select Go Back and Edit.)
                  </span>
               </div>
               <div *ngIf="batch.VerifiedNumParticipantsNotChecked">
                  <div style="color:red;font-weight: bold;">You must confirm the participant count(s) listed above. To make changes, select Go Back and Edit.</div>
               </div>
            </div>
      </div>
      </div>
      <div class="panel">
         <div>
            <button (click)="edit()" class="btn btn-link"><strong>&lt; Go Back and Edit</strong></button>
            <div class="btn-toolbar pull-right">
               <a class="btn btn-link" (click)="reset()">Cancel</a>
               <button class="btn btn-primary" type="submit"
                  (click)="this.Disabled = true; submit(false)">SUBMIT</button>
            </div>
         </div>
      </div>
   </div>
   <div *ngSwitchCase="'confirm'">
      <h3 style="padding:10px;" class="confirmation-message"><span
            class="glyphicon glyphicon-ok-sign text-success pull-left"></span><span class="text-success">Your
            acknowledgement was successfully sent on {{TodaysDate}}.</span><span class="pull-right"><a
               href="/#/admin/retirement-plan-documents/print-distribution-batch/{{RetirementSpdIds}}"
               class="btn btn-link"><span class="icon-utility-print"></span></a></span></h3>
      <div class="panel-body">
         <h4 *ngIf="batch.HasSh">Safe Harbor</h4>
         <h4 *ngIf="batch.HasSpds && batch.HasSmms">Summary Plan Description (SPD) & Summary of Material
            Modifications (SMM)</h4>
         <h4 *ngIf="batch.HasSpds && !batch.HasSmms">Summary Plan Description (SPD)</h4>
         <h4 *ngIf="!batch.HasSpds && batch.HasSmms">Summary of Material Modifications (SMM)</h4>
         <h5>DISTRIBUTION DETAILS</h5>
         <div style="padding-bottom:10px;">
            <div>Date Distributed: {{ batch.DistributionDate | date:'MM/dd/yyyy'}}</div>
            <div>Your Method of Distribution: {{batch.DistributionMethod}}</div>
            <div>Comments: {{batch.Comments? batch.Comments: 'N/A'}} </div>
            <br />
         </div>
         <div *ngIf="!batch.HasSh">
            <h5>PLAN PARTICIPANTS</h5>
            <table class="table">
               <thead>
                  <tr>
                     <th style="cursor:pointer; width:37%;">SUBGROUP &nbsp;</th>
                     <th style="width:23%;cursor:pointer;padding:12px 5px !important;" class="borderLeft">PLAN
                        DOCUMENT
                        &nbsp;</th>
                     <th style="cursor:pointer;width:20%;text-align:left;padding:12px 5px !important;">DOCUMENT TYPE
                        &nbsp;</th>
                     <th style="width:20%;cursor:pointer;text-align:left;padding:12px 5px !important;">#PARTICIPANTS
                        &nbsp;</th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngFor="let item of batch.SubmittedItems">
                     <td>{{item.Organization | uppercase}}</td>
                     <td style="padding:12px 5px !important;"> {{item.PlanDocument}}</td>
                     <td style="padding:12px 5px !important;text-align:left">{{item.DocType}}</td>
                     <td style="padding:12px 5px !important;text-align:left;">{{item.Participants}}</td>
                  </tr>
               </tbody>
            </table>
            <h5>NON-ENGLISH LANGUAGE SURVEY</h5>
            <div>
               <div *ngIf="batch.FewerThan100Participants">
                  <b>Plans with fewer than 100 participants</b>
                  <div>Are 25% or more of all plan participants only literate in a non-English language?
                     {{batch.English25Percent? 'Yes' : 'No'}} </div>
                  <div
                     *ngIf="!batch.English25Percent &amp;&amp; (!batch.MoreThan100Participants || (batch.MoreThan100Participants && batch.English500))">
                     A non-English survey is not required.</div>
                  <div *ngIf="batch.English25Percent">
                     <div>Total number of plan participants who read only the same non-English language:
                        {{batch.NumParticipantsLesser}}</div>
                     <div>What is the non-English language? {{batch.NonEnglishLanguageLesser}} </div>
                  </div>
               </div>
               <br />
               <div *ngIf="batch.MoreThan100Participants">
                  <b>Plans with 100 or more participants</b>
                  <div>Are 500 or more of your plan participants literate only in a non-English language?
                     {{batch.English500? 'Yes' : 'No'}}</div>
                  <div *ngIf="!batch.English500">A non-English survey is not required.</div>
                  <div *ngIf="batch.English500">
                     <div>Are 10% or more of your plan participants literate only in a non-English language?
                        {{batch.English10Percent? 'Yes' : 'No'}}</div>
                     <div>Total number of plan participants who read only the same non-English language:
                        {{batch.NumParticipantsMore}}</div>
                     <div>What is the non-English language? {{batch.NonEnglishLanguageMore}}</div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div class="btn-toolbar pull-right">
         <button (click)="closeConfirm()" class="btn btn-primary">CLOSE</button>
      </div>
   </div>
   <ng-container *ngSwitchDefault>
      <ng-container *ngFor="let organization of organizations; index as i">
         <div
            *ngIf="organization.PendingSpdAcknowledgements.length + organization.PendingSmmAcknowledgements.length + organization.PendingShAcknowledgements.length > 0">
            <div class="row">
               <label style="margin-top:6px;">{{organization.Name}}</label>
               <div class="pull-right">
                  <a class="btn btn-link" routerLink="" (click)="closeOthers(i,true)">Expand All</a>
                  <span>&nbsp;&#124;</span>
                  <a class="btn btn-link pull-right" routerLink="" (click)="closeOthers(i,false)">Collapse All</a>
               </div>
            </div>
            <div *ngIf="collectionsForSorting['pendingshacknowledgementssorted' + i].length > 0" class="accordion"
               style="margin-bottom:0;">
               <div class="accordion-heading">
                  <h4 class="accordion-title">
                     <a class="accordion-toggle" (click)="toggle('pendingshacknowledgementssorted' + i)">
                        <span class="glyphicon collapse-button" [ngClass]="{'glyphicon-minus':isOpen['pendingshacknowledgementssorted' + i] ,
                                       'glyphicon-plus':!isOpen['pendingshacknowledgementssorted' + i]}">
                        </span>
                        <span>Safe Harbor</span>
                     </a>
                  </h4>
               </div>
               <div class="accordion-body" *ngIf="isOpen['pendingshacknowledgementssorted' + i]"
                  style="padding-top: 0;">
                  <div class="row">
                     <span>You may submit your Safe Harbor plan documents.</span>
                  </div>
                  <table style="margin-bottom:0px;" class="table" matSort
                     (matSortChange)='sortDataPendingAcknowledgements($event, i)' matSortActive="PlanDocument"
                     matSortDirection="asc" matSortDisableClear=true>
                     <thead>
                        <tr>
                           <th style="width:4%;"></th>
                           <th style="width:60%;" mat-sort-header='PlanDocument'>PLAN DOCUMENT</th>
                           <th mat-sort-header='EffectiveDateDisplay'>EFFECTIVE DATE</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr *ngFor="let document of collectionsForSorting['pendingshacknowledgementssorted' + i]">
                           <td></td>
                           <td><a href="{{document.DownloadLink}}"
                                 style="margin-left:10px">{{document.PlanDocument}}</a></td>
                           <td>{{document.EffectiveDateDisplay}}</td>
                        </tr>
                     </tbody>
                  </table>
                  <div class="row">
                     <span class="pull-right" *ngIf="isOpen['pendingshacknowledgementssorted' + i]">
                        <button (click)="start('SH',organization.Name);" class="btn btn-sm btn-secondary">START</button>
                     </span>
                  </div>
               </div>
            </div>
            <div class="compact">
               <div class="panel-group">
                  <div
                     *ngIf="(collectionsForSorting['pendingspdacknowledgementssorted' + i].length + collectionsForSorting['pendingsmmacknowledgementssorted' + i].length) > 0"
                     class="accordion">
                     <div class="accordion-heading">
                        <h4 class="accordion-title">
                           <a class="accordion-toggle" (click)="toggle('pendingspdsmmacknowledgementssorted' + i);
                                 toggle('pendingspdacknowledgementssorted' + i);
                                 toggle('pendingsmmacknowledgementssorted' + i);">
                              <span [ngClass]="{'glyphicon-minus':isOpen['pendingspdsmmacknowledgementssorted' + i] ,
                                       'glyphicon-plus':!isOpen['pendingspdsmmacknowledgementssorted' + i]}"
                                 class="glyphicon collapse-button"></span>
                              <span
                                 *ngIf="collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0">Summary
                                 Plan Description (SPD)</span>
                              <span *ngIf="collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0 &&
                           collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0"> & </span>
                              <span
                                 *ngIf="collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0">Summary
                                 of Material Modifications (SMM)</span>
                           </a>
                        </h4>
                     </div>
                     <div
                        [ngClass]="{'accordion-body': collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0 && collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0}"
                        *ngIf="isOpen['pendingspdsmmacknowledgementssorted' + i]" style="padding-top:0;">
                        <div class="row"
                           *ngIf="collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0 && collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0">
                           <span>
                              You may submit both your SPD and SMM plan documents together if they have the same
                              distribution date.</span>
                        </div>
                        <div class="accordion" style="overflow:initial;"
                           *ngIf="collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0">
                           <div class="accordion-heading"
                              *ngIf="collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0 && collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0">
                              <h4 class="accordion-title">
                                 <a class="accordion-toggle" (click)="toggle('pendingspdacknowledgementssorted' + i)">
                                    <span
                                       [ngClass]="{'glyphicon-minus':isOpen['pendingspdacknowledgementssorted' + i] , 'glyphicon-plus':!isOpen['pendingspdacknowledgementssorted' + i]}"
                                       class="glyphicon collapse-button"></span>
                                    <span style="color: rgb(4, 150, 181); font-size:15px;">SPD</span></a>
                              </h4>
                           </div>
                           <div class="accordion-body" *ngIf="isOpen['pendingspdacknowledgementssorted' + i]"
                              style="padding-top:0;">
                              <table style="margin-bottom:0px;" class="table" matSort
                                 (matSortChange)='sortDataPendingAcknowledgements($event, i)'
                                 matSortActive="PlanDocument" matSortDirection="asc" matSortDisableClear=true>
                                 <thead>
                                    <tr>
                                       <th style="width:4%;">
                                          <input type="checkbox" [checked]="organization.SpdMaster"
                                             (click)="organization.SpdMaster = !organization.SpdMaster;toggleSelection('SPD');">
                                       </th>
                                       <th style="width:60%;" mat-sort-header='PlanDocument'>PLAN DOCUMENT</th>
                                       <th mat-sort-header='EffectiveDateDisplay'>EFFECTIVE DATE</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr
                                       *ngFor="let document of collectionsForSorting['pendingspdacknowledgementssorted' + i]">
                                       <td>
                                          <input type="checkbox"
                                             (click)="document.Checked = !document.Checked;checkStart('SPD');"
                                             [checked]="document.Checked">
                                       </td>
                                       <td><a href="{{document.DownloadLink}}">{{document.PlanDocument}}</a></td>
                                       <td>{{document.EffectiveDateDisplay}}</td>
                                    </tr>
                                 </tbody>
                              </table>
                              <div class="row" style="padding-bottom:0;"
                                 *ngIf="collectionsForSorting['pendingsmmacknowledgementssorted' + i].length == 0 && collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0">
                                 <!-- SPD Only Start Button -->
                                 <span class="pull-right">
                                    <span *ngIf="!organization.SmmStartEnabled && !organization.SpdStartEnabled"
                                       style="cursor:pointer;position:relative;top:3px;right:3px;"
                                       title="You must select at least one plan in order to submit your distributions."
                                       class="icon-status-warning">
                                    </span>
                                    <button [disabled]="!organization.SmmStartEnabled && !organization.SpdStartEnabled"
                                       (click)="start('SPD',organization.Name)" class="btn btn-sm btn-secondary">START
                                    </button>
                                 </span>
                              </div>
                           </div>
                        </div>
                        <div class="accordion"
                           *ngIf="collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0">
                           <div class="accordion-heading"
                              *ngIf="collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0 && 
                                                                       collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0">
                              <h4 class="accordion-title">
                                 <a class="accordion-toggle" (click)="toggle('pendingsmmacknowledgementssorted' + i)">
                                    <span
                                       [ngClass]="{'glyphicon-minus':isOpen['pendingsmmacknowledgementssorted' + i] , 'glyphicon-plus':!isOpen['pendingsmmacknowledgementssorted' + i]}"
                                       class="glyphicon collapse-button"></span>
                                    <span style="color: rgb(4, 150, 181); font-size:15px;">SMM</span></a>
                              </h4>
                           </div>
                           <div class="accordion-body" *ngIf="isOpen['pendingsmmacknowledgementssorted' + i]"
                              style="padding-top: 0;">
                              <table style="margin-bottom:0px;" class="table" matSort
                                 (matSortChange)='sortDataPendingAcknowledgements($event, i)'
                                 matSortActive="PlanDocument" matSortDirection="asc" matSortDisableClear=true>
                                 <thead>
                                    <tr>
                                       <th style="width:4%;">
                                          <input type="checkbox" [checked]="organization.SmmMaster"
                                             (click)="organization.SmmMaster = !organization.SmmMaster;toggleSelection('SMM');">
                                       </th>
                                       <th style="width:60%;" mat-sort-header='PlanDocument'>PLAN DOCUMENT</th>
                                       <th mat-sort-header='EffectiveDateDisplay'>EFFECTIVE DATE</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr
                                       *ngFor="let document of collectionsForSorting['pendingsmmacknowledgementssorted' + i]">
                                       <td>
                                          <input type="checkbox"
                                             (click)="document.Checked = !document.Checked; checkStart('SMM');"
                                             [checked]="document.Checked">
                                       </td>
                                       <td><a href="{{document.DownloadLink}}">{{document.PlanDocument}}</a></td>
                                       <td>{{document.EffectiveDateDisplay}}</td>
                                    </tr>
                                 </tbody>
                              </table>
                              <div class="row" style="padding-bottom:0;"
                                 *ngIf="collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0 && collectionsForSorting['pendingspdacknowledgementssorted' + i].length == 0">
                                 <!-- SMM Only Start Button -->
                                 <span class="pull-right">
                                    <span *ngIf="!organization.SmmStartEnabled && !organization.SpdStartEnabled"
                                       style="cursor:pointer;position:relative;top:3px;right:3px;"
                                       title="You must select at least one plan in order to submit your distributions."
                                       class="icon-status-warning">
                                    </span>
                                    <button [disabled]="!organization.SmmStartEnabled && !organization.SpdStartEnabled"
                                       (click)="start('SPD',organization.Name)" class="btn btn-sm btn-secondary">START
                                    </button>
                                 </span>
                              </div>
                           </div>
                        </div>
                        <div class="row" style="padding-bottom:0;"
                           *ngIf="collectionsForSorting['pendingsmmacknowledgementssorted' + i].length > 0 && collectionsForSorting['pendingspdacknowledgementssorted' + i].length > 0">
                           <span class="pull-right">
                              <!-- START button when both SPD & SMM present -->
                              <span *ngIf="!organization.SmmStartEnabled && !organization.SpdStartEnabled"
                                 style="cursor:pointer;position:relative;top:3px;right:3px;"
                                 title="You must select at least one plan in order to submit your distributions."
                                 class="icon-status-warning">
                              </span>
                              <button [disabled]="!organization.SmmStartEnabled && !organization.SpdStartEnabled"
                                 (click)="start('SPD',organization.Name)" class="btn btn-sm btn-secondary">START
                              </button>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </ng-container>
      <span *ngIf="distributionCount === 0 && !documentsLoading">There are no distributions requiring
         acknowledgement.</span>
   </ng-container>
</div>